document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-copy-coupon]');
  if (!button) return;

  const code = button.getAttribute('data-copy-coupon') || '';
  if (!code) return;

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).catch(() => {});
  }

  const previous = button.textContent;
  button.textContent = 'Copied';
  button.setAttribute('data-copied', 'true');

  window.setTimeout(() => {
    button.textContent = previous;
    button.removeAttribute('data-copied');
  }, 1200);
});
